<template>
  <div class="loading-placeholder" :class="modifierClass">
    <div class="loading-placeholder__sub-navigation"></div>
    <div class="container">
      <div class="loading-placeholder__content">
        <section class="loading-placeholder__heading"></section>
        <div class="loading-placeholder__list">
          <section
            v-for="index in itemsNumber"
            :key="`placeholder-card-${index}`"
            class="loading-placeholder__card"
          >
            <div v-if="showCardImage" class="loading-placeholder__card-image"></div>
          </section>
        </div>
        <loading-spinner />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { LoadingPlaceholderProps } from './types';
import LoadingSpinner from '../../../components/2_elements/LoadingSpinner/LoadingSpinner.vue';

const props = withDefaults(defineProps<LoadingPlaceholderProps>(), {
  showCardImage: false,
});

const modifierClass = props.modifierName ? `loading-placeholder--${props.modifierName}` : null;
</script>

<style lang="scss">
@import './scss/LoadingPlaceholder.scss';
</style>
